"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosBarcodeCreateInputSchema = exports.APosBarcodeIndexSchema = exports.APosBarcodeTypeSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
exports.APosBarcodeTypeSchema = zod_1.z.enum([
    'manufacturer', 'supplier', 'internal', 'historical',
]);
// Channel-agnostic barcode index — NO price stored.
// At scan time: barcode → all variantIds, then VariantLocation[locationId].{channel}.price × quantity
// Key structure: PK = {tenantId}#{barcode}, SK = variantId (sort key enables multi-variant per barcode)
// A barcode can be assigned to multiple variants. Internal barcodes must be unique per tenant.
// Manufacturer/supplier barcodes can be shared across variants.
exports.APosBarcodeIndexSchema = zod_1.z.object({
    pk: zod_1.z.string().min(1).describe('Composite key: tenantId#barcode'),
    tenantId_variantId: zod_1.z.string().min(1).describe('GSI key: tenantId#variantId'),
    variantId: id_schema_1.EntityIdSchema, // Also serves as sort key (SK) in the DynamoDB table
    productId: id_schema_1.EntityIdSchema,
    tenantId: id_schema_1.TenantIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    thumbnail: zod_1.z.string().url().optional(),
    barcodeType: exports.APosBarcodeTypeSchema,
    isPrimary: zod_1.z.boolean().default(false),
    quantity: zod_1.z.number().int().positive().default(1),
    createdAt: zod_1.z.number(),
});
exports.APosBarcodeCreateInputSchema = zod_1.z.object({
    barcode: zod_1.z.string().min(1),
    variantId: id_schema_1.EntityIdSchema,
    productId: id_schema_1.EntityIdSchema,
    displayName: zod_1.z.string().min(1),
    sku: zod_1.z.string().optional(),
    thumbnail: zod_1.z.string().url().optional(),
    barcodeType: exports.APosBarcodeTypeSchema,
    isPrimary: zod_1.z.boolean().optional(),
    quantity: zod_1.z.number().int().positive().optional(),
});
//# sourceMappingURL=barcode-index.schema.js.map